// extracted by mini-css-extract-plugin
export var readonly = "_ib-1";
export var star = "_ib-0";